(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["arandu-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arandu-size-chart')) {
    const toInch = (text) =>
      text.replace(/\d+(?:[.,]\d+)?/g, (n) => (parseFloat(n.replace(',', '.')) / 2.54).toFixed(2));

    class AranduSizeChart extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-sc-open]');
        this.overlay = this.querySelector('[data-sc-overlay]');
        if (!this.trigger || !this.overlay) return;

        // Move o modal para o <body> para escapar de containers com transform/overflow do tema
        document.body.appendChild(this.overlay);

        this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
        this.trigger.addEventListener('click', () => this.open());
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay || e.target.closest('[data-sc-close]')) this.close();
        });
        this.overlay.querySelectorAll('[data-sc-table]').forEach((t) => this.setupSwitcher(t));
      }

      disconnectedCallback() {
        if (this.overlay && !this.overlay.hidden) this.close();
        this.overlay?.remove();
      }

      open() {
        this.prevOverflow = document.body.style.overflow;
        this.overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);
        this.overlay.querySelector('[data-sc-close]')?.focus();
      }

      close() {
        this.overlay.hidden = true;
        document.body.style.overflow = this.prevOverflow || '';
        document.removeEventListener('keydown', this.onKey);
        this.trigger?.focus();
      }

      setupSwitcher(table) {
        const buttons = table.querySelectorAll('[data-unit]');
        if (!buttons.length) return;
        buttons.forEach((btn) =>
          btn.addEventListener('click', () => {
            const unit = btn.dataset.unit;
            buttons.forEach((b) => {
              const active = b === btn;
              b.classList.toggle('is-active', active);
              b.setAttribute('aria-pressed', active);
            });
            table.querySelectorAll('[data-unit-label]').forEach((l) => {
              l.textContent = unit === 'in' ? '(inch)' : '(cm)';
            });
            table.querySelectorAll('td[data-cm]').forEach((td) => {
              td.textContent = unit === 'in' ? toInch(td.dataset.cm) : td.dataset.cm;
            });
          })
        );
      }
    }

    customElements.define('arandu-size-chart', AranduSizeChart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-carousel')) {
    class VideoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vc-track]');
        this.prev = this.querySelector('[data-vc-prev]');
        this.next = this.querySelector('[data-vc-next]');
        this.modal = this.querySelector('[data-vc-modal]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.sound = this.dataset.sound === 'true';
        this.idx = 0;

        /* Setas: avança 1 card */
        const step = () => {
          const c = this.cards()[0];
          return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 0;
        };
        this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step() }));
        this.next?.addEventListener('click', () => this.track.scrollBy({ left: step() }));
        this.onScroll = () => requestAnimationFrame(() => this.updateArrows());
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.ro = new ResizeObserver(() => this.updateArrows());
        this.ro.observe(this.track);

        /* Lazy load + tocar só quando visível */
        this.io = new IntersectionObserver((entries) => {
          entries.forEach(({ target: v, isIntersecting }) => {
            if (isIntersecting) {
              if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; v.preload = 'metadata'; }
              if (this.autoplay) v.play().catch(() => {});
            } else {
              v.pause();
            }
          });
        }, { rootMargin: '300px' });
        this.track.querySelectorAll('video[data-src]').forEach((v) => this.io.observe(v));

        /* Clique no card */
        this.track.addEventListener('click', (e) => {
          const card = e.target.closest('.vc__card');
          if (!card || card.hasAttribute('data-empty')) return;
          const i = this.cards().indexOf(card);
          if (this.modal) this.open(i);
          else this.toggleInline(card);
        });

        if (this.modal) this.setupModal();
        this.updateArrows();
      }

      disconnectedCallback() {
        this.io?.disconnect();
        this.ro?.disconnect();
        if (this.modal?.open) this.modal.close();
        if (this.modal && this.modal.parentElement === document.body) this.modal.remove();
        if (this.onWinClick) window.removeEventListener('click', this.onWinClick, true);
        if (this.onKey) document.removeEventListener('keydown', this.onKey);
      }

      cards() { return [...this.track.querySelectorAll('.vc__card:not([data-empty])')]; }

      updateArrows() {
        if (!this.prev || !this.next) return;
        const t = this.track;
        const overflow = t.scrollWidth > t.clientWidth + 2;
        this.prev.disabled = !overflow || t.scrollLeft <= 10;
        this.next.disabled = !overflow || t.scrollLeft + t.clientWidth >= t.scrollWidth - 10;
      }

      toggleInline(card) {
        const v = card.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (v.paused) v.play().catch(() => {});
      }

      setupModal() {
        const m = this.modal;
        this.mv = m.querySelector('[data-vc-modal-video]');
        this.frame = m.querySelector('.vc-modal__frame');
        this.inner = m.querySelector('.vc-modal__inner');
        this.closeBtn = m.querySelector('[data-vc-close]');
        this.muteBtn = m.querySelector('[data-vc-mute]');
        this.mprev = m.querySelector('[data-vc-mprev]');
        this.mnext = m.querySelector('[data-vc-mnext]');

        m.addEventListener('close', () => {
          this.mv.pause(); this.mv.removeAttribute('src'); this.mv.load();
          document.documentElement.style.overflow = '';
          if (m.parentElement !== this) this.appendChild(m);   /* devolve o modal ao bloco */
        });
        this.mv.addEventListener('play', () => this.frame.classList.remove('is-paused'));
        this.mv.addEventListener('pause', () => this.frame.classList.add('is-paused'));

        /* Cliques tratados na captura da janela, pelas coordenadas: funciona mesmo que
           algum elemento do tema fique por cima do modal ou intercepte o clique. */
        this.onWinClick = (e) => {
          if (!m.open) return;
          const x = e.clientX, y = e.clientY;
          const hit = (el) => {
            if (!el || el.disabled) return false;
            const r = el.getBoundingClientRect();
            return r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
          };
          if (hit(this.closeBtn)) m.close();
          else if (hit(this.mprev)) this.show(this.idx - 1);
          else if (hit(this.mnext)) this.show(this.idx + 1);
          else if (hit(this.muteBtn)) { this.mv.muted = !this.mv.muted; this.setMuteIcon(); }
          else if (hit(this.frame)) { this.mv.paused ? this.mv.play().catch(() => {}) : this.mv.pause(); }
          else if (!hit(this.inner)) m.close();
          e.preventDefault();
          e.stopPropagation();
        };
        window.addEventListener('click', this.onWinClick, true);

        this.onKey = (e) => {
          if (!m.open) return;
          if (e.key === 'ArrowRight') this.show(this.idx + 1);
          if (e.key === 'ArrowLeft') this.show(this.idx - 1);
          if (e.key === ' ') { e.preventDefault(); this.mv.paused ? this.mv.play() : this.mv.pause(); }
        };
        document.addEventListener('keydown', this.onKey);
      }

      open(i) {
        document.documentElement.style.overflow = 'hidden';
        /* Move o modal para o <body> enquanto aberto, fugindo de estilos herdados da coluna do produto */
        const ratio = getComputedStyle(this).getPropertyValue('--vc-ratio');
        if (ratio) this.modal.style.setProperty('--vc-ratio', ratio);
        document.body.appendChild(this.modal);
        this.modal.showModal();
        this.show(i);
      }

      show(i) {
        const cards = this.cards();
        if (i < 0 || i >= cards.length) return;
        this.idx = i;
        const src = cards[i].querySelector('video')?.dataset.src;
        if (!src) return;
        this.mv.src = src;
        this.mv.muted = !this.sound;
        this.setMuteIcon();
        this.mv.play().catch(() => { this.mv.muted = true; this.setMuteIcon(); this.mv.play().catch(() => {}); });
        this.mprev.disabled = i === 0;
        this.mnext.disabled = i === cards.length - 1;
      }

      setMuteIcon() {
        this.muteBtn.classList.toggle('is-muted', this.mv.muted);
      }
    }
    customElements.define('video-carousel', VideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
